module.exports = __webpack_public_path__ + "img/calendar-alt.ad2925bf.svg";